import _ from 'lodash';

import { hasTagsChanged } from '../../tags/utils';

import { itemPropertiesByPackType } from '../../settings';

import { Pack } from '../../types/packTypes';
import { Tag } from '../../types/tagTypes';

export function hasAboutChanged(packA: Pack, packB: Pack) {
    const aboutProperties = ['name', 'packId', 'displayName', 'features'];
    return !_.isEqual(
        _.pick(packA, aboutProperties),
        _.pick(packB, aboutProperties),
    );
}
export function hasItemsChanged(packA: Pack, packB: Pack) {
    return !_.isEqual(
        _.pick(packA, itemPropertiesByPackType[packA.type]),
        _.pick(packB, itemPropertiesByPackType[packB.type]),
    );
}
export function hasMediasChanged(packA: Pack, packB: Pack) {
    const packMediasA = packA.medias.map((media) =>
        _.pick(media, ['type', 'md5']),
    );
    const packMediasB = packB.medias.map((media) =>
        _.pick(media, ['type', 'md5']),
    );
    return !_.isEqual(packMediasA, packMediasB);
}

export function hasPackTagsChanged(
    sourcePack: Pack,
    targetPack: Pack,
    sourceTags: Tag[],
    targetTags: Tag[],
) {
    return hasTagsChanged(
        sourcePack.tags ?? [],
        targetPack.tags ?? [],
        sourceTags,
        targetTags,
    );
}

export function hasPackChanged(
    packA: Pack,
    packB: Pack,
    options: {
        sourceTags?: Tag[];
        targetTags?: Tag[];
    } = {},
) {
    const omitProps: (keyof Pack)[] = ['medias', 'tags'];
    const nonMediaChanged = !_.isEqual(
        _.omit(packA, omitProps),
        _.omit(packB, omitProps),
    );
    if (nonMediaChanged) return true;
    if (hasMediasChanged(packA, packB)) return true;

    const { sourceTags, targetTags } = options;
    if (sourceTags && targetTags) {
        return hasPackTagsChanged(packA, packB, sourceTags, targetTags);
    }
    // Fallback to raw comparison (only meaningful when tag IDs are shared).
    return !_.isEqual(packA.tags ?? [], packB.tags ?? []);
}
